import { requestEnvelope } from './client'
import { earthquakeSchema, nullableArray, paginated, type Earthquake } from './schemas'
import type { QuakeFilter } from '../lib/query-keys'

export async function listEarthquakes(f: QuakeFilter) {
  const params = new URLSearchParams({
    status: f.status,
    page: String(f.page),
    pageSize: String(f.pageSize),
  })
  const data = await requestEnvelope(`/earthquakes?${params.toString()}`, paginated(earthquakeSchema))
  return data
}

export async function listRecentEarthquakes(limit = 20): Promise<Earthquake[]> {
  return requestEnvelope(`/earthquakes/recent?limit=${limit}`, nullableArray(earthquakeSchema))
}

export async function getEarthquake(id: string): Promise<Earthquake> {
  return requestEnvelope(`/earthquakes/${encodeURIComponent(id)}`, earthquakeSchema)
}
